export { default } from './MobileStaticMap';
